import { Case, CaseType } from '../types/hr.types'

// In-memory store for the session
let cases: Case[] = []

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const caseService = {
  async createITCase(candidateId: string): Promise<Case> {
    await delay(800) // Simulate network delay

    // Idempotency check
    const existing = cases.find(
      (c) => c.candidateId === candidateId && c.type === 'IT',
    )
    if (existing) {
      throw new Error('An IT case already exists for this candidate.')
    }

    const newCase: Case = {
      id: `CASE-IT-${Date.now()}`,
      type: 'IT',
      candidateId,
      checklistItems: [
        'Create Microsoft Account',
        'Setup Salesforce Access',
        'Configure Teams',
        'Provision Outlook Email',
        'Procure Laptop/Computer',
      ],
      createdAt: new Date().toISOString(),
      status: 'New',
    }

    cases.push(newCase)
    return newCase
  },

  async createMarketingCase(candidateId: string): Promise<Case> {
    await delay(800) // Simulate network delay

    // Idempotency check
    const existing = cases.find(
      (c) => c.candidateId === candidateId && c.type === 'Marketing',
    )
    if (existing) {
      throw new Error('A Marketing case already exists for this candidate.')
    }

    const newCase: Case = {
      id: `CASE-MKT-${Date.now()}`,
      type: 'Marketing',
      candidateId,
      checklistItems: [
        'Schedule Headshots',
        'Order Building Badge/Access Card',
      ],
      createdAt: new Date().toISOString(),
      status: 'New',
    }

    cases.push(newCase)
    return newCase
  },

  async getCasesForCandidate(candidateId: string): Promise<Case[]> {
    await delay(300)
    return cases.filter((c) => c.candidateId === candidateId)
  },
}
